import axiosInstance from "./axiosInstance";

const getBadgeById = async (badgeId: number) => {
  const accessToken = localStorage.getItem("accessTokenGC");
  try {
    const {data} = await axiosInstance.get(`/api/getBadgeById/${badgeId}`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return data;
  } catch (error) {
    throw new Error("Error fetching user points.");
  }
};

export default getBadgeById;
